import {
  IconButton,
  TableToolbarAction,
  TableToolbarContent,
  TableToolbarMenu,
  TableToolbarSearch
} from '@carbon/react';
import { Filter, Reset } from '@carbon/react/icons';

import { SORT } from 'features/all-projects/filters';

const TableFiltersToolbar = ({ onSortChange, onReset, searchValue, onSearchChange, onSearchReset }) => (
  <TableToolbarContent>
    <TableToolbarSearch
      tabIndex={0}
      onChange={(e) => (e.target.value ? onSearchChange(e.target.value) : onSearchReset())}
      value={searchValue}
    />
    <IconButton label="Reset" kind="ghost" size="sm" onClick={onReset}>
      <Reset />
    </IconButton>
    <TableToolbarMenu renderIcon={Filter} iconDescription="Sort">
      <TableToolbarAction onClick={() => onSortChange(SORT.alphabetically)}>Sort alphabetically</TableToolbarAction>
      <TableToolbarAction onClick={() => onSortChange(SORT.lastModified)}>Sort by update date</TableToolbarAction>
      <TableToolbarAction onClick={() => onSortChange(SORT.startDate)}>Sort by start date</TableToolbarAction>
      <TableToolbarAction onClick={() => onSortChange(SORT.tier)}>Sort by tier</TableToolbarAction>
    </TableToolbarMenu>
  </TableToolbarContent>
);

export default TableFiltersToolbar;
